import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { selectAuth } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import PreSaleGymLeadsStructure from "../../components/lead-management/pre-sale-gym-leads/PreSaleGymLeadsStructure";

const PreSaleGymLeads = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return (
    <HelmetWrapper title="WTF: Pre Sale Gym Leads">
      <Container className="bg-cloud-k px-50px" fluid>
        <PreSaleGymLeadsStructure userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default PreSaleGymLeads;
